// extracted by mini-css-extract-plugin
export default {"headerButton":"TemplateComparisonView_headerButton__i66mu"};